import React, {useEffect, useState} from 'react';
import Head from "./Head";
import Footer from "./Footer";
import Wrapper from "./drawing/Wrapper";
import {drawingV2} from "../../constant/dump";
import _ from "lodash";

const MainTable = (props) => {
    const [result, setResult] = useState(drawingV2);

    const onStartDraw = (result) => {
        setResult(result)
    }

    useEffect(() => {
        setResult(!_.isEmpty(props.drawResult.data) ? props.drawResult.data : drawingV2)
    }, [props.drawResult]);

    return (
        <div id="main-live" className="h-100">
            <Head/>
            <div className="body-live-wrap">
                <Wrapper onStartDraw={onStartDraw} result={result} {...props}/>
            </div>
            <Footer/>
        </div>
    );
};

export default MainTable;